export const setLanguage = (value) => ({
    type: "setLanguage",
    value: value,
});

export const setTimeOutLogoutMessage = (value) => ({
    type: "setTimeOutLogoutMessage",
    value: value,
});

export const setIsAuthenticated = (value) => ({
    type: "setIsAuthenticated",
    value: value,
});


export const setAppInit = (value) => ({
    type: "setAppInit",
    value: value,
});

export const setLoading = (value) => ({
    type: "setLoading",
    value: value,
});

export const setSelectedClaim = (value) => ({
    type: "setSelectedClaim",
    payload: parseInt(value, 10),
});

export const setStep1 = (value) => ({
    type: "setStep1",
    payload: value,
});

export const setUnemploymentForm = (value) => ({
    type: "setUnemploymentForm",
    payload: value,
});
export const setWorkIncapacityForm = (value) => ({
    type: "setWorkIncapacityForm",
    payload: value,
});

export const setHospitalisedForm = (value) => ({
    type: "setHospitalisedForm",
    payload: value,
});

export const setCustomer = (value) => ({
    type: "setCustomer",
    payload: value,
});

export const setInsurances = (value) => ({
    type: "setInsurances",
    payload: value,
});

export const setClaimEvents = (value) => ({
    type: "setClaimEvents",
    payload: value,
});
export const setClaimDate = (value) => ({
    type: "setClaimDate",
    payload: value,
});

